<template>
  <v-layout>
    <v-snackbar
      v-model="success.show"
      color="success"
      top
      :timeout="success.timeout"
      text-xs-center
    >
      {{ success.message }}
      <v-icon right dark>check</v-icon>
    </v-snackbar>
    <!--<v-toolbar color="#2d4d85" dark fixed app clipped-right>-->
    <v-toolbar color="#421773" dark fixed app clipped-right>
      <v-toolbar-side-icon @click="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>
        <img
          :src="require('@/assets/img/logo_e-egyetem_classroom_logo_white.png')"
          height="45px"
          class="mb-1"
        />
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <!--<v-btn -->
        <!--    @click="getLeaderBoardData()"-->
        <!--    color="mainGreen"-->
        <!--    class="hidden-md-and-up"-->
        <!--    icon-->
        <!--    title="Dicsőségfal"-->
        <!--&gt;-->
        <!--    <v-icon>stars</v-icon>-->
        <!--    &lt;!&ndash; Dicsőségfal &ndash;&gt;-->
        <!--</v-btn>-->

        <v-btn @click="goToMessages()" color="" class="" icon title="Üzenetek">
          <v-badge v-if="unreadMessages" color="red">
            <template v-slot:badge>
              <span>!</span>
            </template>
            <v-icon>
              email
            </v-icon>
          </v-badge>

          <v-badge v-else color="red">
            <v-icon>
              email
            </v-icon>
          </v-badge>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
      fixed
      clipped
      style="position: fixed; top:0;"
    >
      <v-list>
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <img v-if="user.profile_photo" :src="profilePhoto" />
            <img v-else :src="require('@/assets/img/user.png')" />
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>
              {{ user.name }}
            </v-list-tile-title>
            <v-list-tile-title class="titleAlt">
              {{ user.email }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <v-list dense>
        <v-divider></v-divider>

        <v-list-tile @click="$router.push({ name: 'chooser' })">
          <v-list-tile-action>
            <v-icon>home</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>Főoldal</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <!--<v-list-tile @click="$router.push({ name: 'profile' })">-->
        <!--  <v-list-tile-action>-->
        <!--    <v-icon>face</v-icon>-->
        <!--  </v-list-tile-action>-->

        <!--  <v-list-tile-content>-->
        <!--    <v-list-tile-title>Profilom</v-list-tile-title>-->
        <!--  </v-list-tile-content>-->
        <!--</v-list-tile>-->

        <!--<v-list-tile @click="$router.push({ name: 'diploma' })">-->
        <!--  <v-list-tile-action>-->
        <!--    <v-icon>assignment</v-icon>-->
        <!--  </v-list-tile-action>-->

        <!--  <v-list-tile-content>-->
        <!--    <v-list-tile-title>Okleveleim</v-list-tile-title>-->
        <!--  </v-list-tile-content>-->
        <!--</v-list-tile>-->

        <v-list-tile @click="$router.push({ name: 'settings' })">
          <v-list-tile-action>
            <v-icon>build</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>Beállítások</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile @click="$router.push({ name: 'logout' })">
          <v-list-tile-action>
            <v-icon>input</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>Kijelentkezés</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-dialog v-model="pin.show" persistent max-width="600px">
      <v-snackbar
        v-model="error.show"
        color="error"
        top
        :timeout="error.timeout"
        text-xs-center
      >
        {{ error.message }}
        <v-icon right dark>error_outline</v-icon>
      </v-snackbar>
      <v-card>
        <v-card-title
          class="headline blue"
          primary-title
          dark
          style="color: white;"
        >
          Fiók megerősítése
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-form>
                  <v-text-field
                    prepend-icon="more_horiz"
                    name="pin.code"
                    label="PIN kód"
                    type="text"
                    :rules="[rules.required]"
                    v-model="pin.code"
                  ></v-text-field>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="pin.show = !pin.show">
            <v-icon left dark>close</v-icon>
            Mégsem
          </v-btn>
          <v-btn color="primary" @click="sendPin">
            Érvényesít
            <v-icon right dark>input</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="leaderBoard.show"
      fullscreen
      lazy
      hide-overlay
      transition="dialog-bottom-transition"
      style="overflow: hidden;"
    >
      <v-card>
        <v-toolbar dark color="#2d4d85">
          <v-btn icon dark @click="leaderBoard.show = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <v-icon>star</v-icon>
            Dicsőségfal
            <v-icon>star</v-icon>

            <!-- <v-btn color="info" fab small @click="showCalculationsInfo()">
                        <v-icon class="text-light">info</v-icon>
                    </v-btn> -->
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="leaderBoard.show = false">Bezár</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-layout row wrap>
          <v-flex
            v-for="(data, index) in leaderBoard.datas"
            :key="index"
            xs10
            offset-xs1
          >
            <v-card
              color=""
              class="p-1 pilledLight leaderBoardRow"
              :class="index === 0 ? 'mt-2' : 'mt-1'"
            >
              <v-layout row wrap class="p-2">
                <v-flex xs2 text-xs-center> {{ data.position }}. </v-flex>
                <v-flex xs6 text-xs-left class="leaderBoardName">
                  <strong>{{ data.nickname }}</strong>
                </v-flex>
                <v-flex xs4 text-xs-right class="pr-2">
                  <span class="leaderBoardPoint"> {{ data.score }} </span>
                  <sub>pont</sub>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex offset-xs1 xs10>
            <v-card color="mainBlue" class="mt-2 p-1 pilledLight" dark>
              A Te helyezésed: <br />
              <v-layout row wrap class="p-2 leaderBoardRow">
                <v-flex xs2 text-xs-center>
                  {{ leaderBoard.user.position }}.
                </v-flex>
                <v-flex xs6 text-xs-left>
                  <strong>{{ leaderBoard.user.nickname }}</strong>
                </v-flex>
                <v-flex xs4 text-xs-right class="pr-2">
                  <span class="leaderBoardPoint">
                    {{ leaderBoard.user.score }}
                  </span>
                  <sub>pont</sub>
                </v-flex>
              </v-layout>
              <!-- Helyezésed: {{ leaderBoard.user.position }} / {{ leaderBoard.allUsersCount }} -->
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="calculationsInfo.show"
      fullscreen
      lazy
      hide-overlay
      transition="dialog-bottom-transition"
      style="overflow: hidden;"
    >
      <v-card>
        <v-toolbar dark color="#2d4d85">
          <v-btn icon dark @click="calculationsInfo.show = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <v-icon>star</v-icon>
            Pontszámítás

            <v-btn color="info" fab small @click="showCalculationsInfo()">
              <v-icon class="text-light">info</v-icon>
            </v-btn>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="calculationsInfo.show = false"
              >Bezár</v-btn
            >
          </v-toolbar-items>
        </v-toolbar>

        <v-layout row wrap>
          <v-flex offset-xs1 xs10>
            pontszámítás ide
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from "axios";
import Logout from "@/components/Logout";
import { mapState } from "vuex";

export default {
  components: {},
  data: () => ({
    drawer: false,
    user: "",
    verified: false,
    pin: {
      code: "",
      show: false
    },
    error: {
      show: false,
      code: "",
      message: "",
      timeout: 3500
    },
    success: {
      show: false,
      code: "",
      message: "",
      timeout: 3500
    },
    rules: {
      required: value => !!value || "Kötelező"
    },
    leaderBoard: {
      show: false,
      datas: "",
      user: "",
      allUsersCount: ""
    },
    calculationsInfo: {
      show: false
    },
    unreadMessages: false
  }),
  methods: {
    sendPin() {
      axios
        .post(this.$store.getters.getApiUrl + "/api/registration/pin", {
          token: this.$store.getters.getToken,
          pin: this.$data.pin.code
        })
        .then(response => {
          this.$data.pin.show = false;
          this.$data.error.show = false;

          this.$data.user = response.data.currentUser;
          this.$data.success.message = response.data.message;
          this.$data.success.code = response.data.code;
          this.$data.success.show = true;

          getUserData();
        })
        .catch(error => {
          if (error.length > 1 && error !== undefined) {
            this.$data.error.message = error.response.data.message;
            this.$data.error.code = error.response.data.code;
            this.$data.error.show = true;
          }
        });
    },
    getUserData() {
      //Get the curent user data
      this.$data.user = this.$store.getters.currentUser;

      //Check the unreaded messages
      axios
        .post(this.$store.getters.getApiUrl + "/api/leaderboard/getData", {
          token: this.$store.getters.getToken
        })
        .then(response => {
          // console.log('leaderBoard - response: ', response.data);

          //Load the responsed data
          this.$data.leaderBoard.datas = response.data.leaderBoardDatas;
          this.$data.leaderBoard.user = response.data.userData;
          this.$data.leaderBoard.allUsersCount = response.data.allUsersCount;

          //Show the modal
          this.$data.leaderBoard.show = false;
        })
        .catch(error => {
          if (error.length > 0) {
            console.log("leaderBoard - error: ", error);
          }
        });
    },
    checkMessage() {
      //Get the curent user data
      this.$data.user = this.$store.getters.currentUser;

      //Check the unreaded messages
      axios
        .post(this.$store.getters.getApiUrl + "/api/message/checkMessage", {
          token: this.$store.getters.getToken,
          userId: this.$data.user.id
        })
        .then(response => {
          // console.log('checkmessage - response: ', response.data);

          //Load the responsed data
          this.$data.unreadMessages = response.data.unreadMessages;
        })
        .catch(error => {
          if (error.length > 0) {
            console.log("leaderBoard - error: ", error);
          }
        });
    },
    goToEEgytemLogIn() {
      window.open(this.$store.getters.getEEgyetemLoginUrl, "_blank");
      // this.$data.languageLabor.show = true;
    },
    getLeaderBoardData() {
      axios
        .post(this.$store.getters.getApiUrl + "/api/leaderboard/getData", {
          token: this.$store.getters.getToken
        })
        .then(response => {
          console.log("leaderBoard - response: ", response.data);

          //Load the responsed data
          this.$data.leaderBoard.datas = response.data.leaderBoardDatas;
          this.$data.leaderBoard.user = response.data.userData;
          this.$data.leaderBoard.allUsersCount = response.data.allUsersCount;

          //Show the modal
          this.$data.leaderBoard.show = true;
        })
        .catch(error => {
          if (error.length > 0) {
            console.log("leaderBoard - error: ", error);
          }
        });
    },
    showCalculationsInfo() {
      this.$data.leaderBoard.show = false;
      this.$data.calculationsInfo.show = true;
    },
    goToMessages() {
      this.$router.push({ name: "messages" });
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.currentUser
    }),
    profilePhoto() {
      if (this.$store.getters.currentUser.profile_photo !== undefined) {
        return (
          this.$store.getters.getApiUrl +
          "/uploads/profile_photos/" +
          this.$store.getters.currentUser.profile_photo
        );
      } else {
        return (
          this.$store.getters.getApiUrl + "/uploads/profile_photos/empty.png"
        );
      }
    }
  },
  created: function() {
    // We dont use leaderboard
    // this.getUserData();

    //Check unread messages
    this.checkMessage();
  }
};
</script>
